import { render, staticRenderFns } from "./AllMenu.vue?vue&type=template&id=de678078&scoped=true"
import script from "./AllMenu.vue?vue&type=script&lang=js"
export * from "./AllMenu.vue?vue&type=script&lang=js"
import style0 from "./AllMenu.vue?vue&type=style&index=0&id=de678078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de678078",
  null
  
)

export default component.exports